export const urlHandler = {
    "Henry Schein Dental": {
        "en": {
           footer_privacy_statement:"",
           footer_terms_conditions:"https://www.henryschein.ca/ca-en/dental/thrive-rewards/thrive-rewards-terms-conditions.aspx?cdivid=dental-ca",
           footer_program_details:"",
           footer_faq:"",
           footer_website:"",
           header_henryschein_website:"https://www.henryschein.com"
        },
    },
    "Henry Schein Canada": {
        "en": {
            footer_privacy_statement:"",
            footer_terms_conditions:"https://www.henryschein.ca/ca-en/dental/thrive-rewards/thrive-rewards-terms-conditions.aspx?cdivid=dental-ca",
            footer_program_details:"",
            footer_faq:"",
            footer_website:"",
            header_henryschein_website:"https://www.henryschein.ca/en-ca" 
        },
        "fr": {
            footer_privacy_statement:"",
            footer_terms_conditions:"https://www.henryschein.ca/ca-fr/dental/thrive-rewards/thrive-rewards-terms-conditions.aspx?cdivid=dental-ca",
            footer_program_details:"",
            footer_faq:"",
            footer_website:"",
            header_henryschein_website:"https://www.henryschein.ca/fr-ca"
        }
    }
}